<template>
  <t-card style="margin-top: -20px">
    <t-form
      ref="productInfoForm"
      :model="productInfoForm"
      label-position="right"
      label-width="100px"
      class="productInfoForm"
      domain="productInfoForm"
    >
      <t-row>
        <!-- 製品コード -->
        <t-col :span="12">
          <t-form-item
            :label="$t('resource.productInfo.productCode')"
            prop="cusCode"
          >
            <t-input
              v-model="productInfoForm.productCode"
              :disabled="disabled"
              maxLength="11"
            ></t-input> </t-form-item
        ></t-col>
      </t-row>
      <t-row>
        <t-col :span="12">
          <!-- 商品名 -->
          <t-form-item
            :label="$t('resource.productInfo.productName')"
            prop="productName"
          >
            <t-input
              v-model="productInfoForm.productName"
              maxLength="11"
            ></t-input> </t-form-item
        ></t-col>
        <t-col :span="12">
          <!-- 材质号 -->
          <t-form-item
            :label="$t('resource.productInfo.materialNum')"
            prop="materialNum"
          >
            <t-input
              v-model="productInfoForm.materialNum"
              maxLength="20"
            ></t-input></t-form-item
        ></t-col>
      </t-row>
      <t-row>
        <t-col :span="12">
          <!-- 図番 -->
          <t-form-item
            :label="$t('resource.productInfo.diagram')"
            prop="diagram"
          >
            <t-input
              v-model="productInfoForm.diagram"
              maxLength="20"
            ></t-input></t-form-item
        ></t-col>
        <t-col :span="12">
          <!-- 形状 -->
          <t-form-item :label="$t('resource.productInfo.shape')" prop="shape">
            <t-input
              v-model="productInfoForm.shape"
              maxLength="20"
            ></t-input> </t-form-item
        ></t-col>
      </t-row>

      <t-row
        ><t-col :span="12">
          <!-- 重量 -->
          <t-form-item :label="$t('resource.productInfo.weight')" prop="weight">
            <t-input
              v-model="productInfoForm.weight"
              maxLength="20"
              style="width: 200px"
            ></t-input>
            kg/個
          </t-form-item></t-col
        >
        <t-col :span="12">
          <!-- 体積 -->
          <t-form-item :label="$t('resource.productInfo.volume')" prop="volume">
            <t-input
              v-model="productInfoForm.volume"
              maxLength="20"
            ></t-input> </t-form-item
        ></t-col>
      </t-row>
      <t-row>
        <t-col :span="12">
          <!-- 単位 -->
          <t-form-item :label="$t('resource.productInfo.unit')" prop="unit">
            <t-input
              v-model="productInfoForm.unit"
              maxLength="20"
            ></t-input> </t-form-item
        ></t-col>
        <!-- 画像 -->
        <!-- <t-col :span="12" 　v-show="false">
          <t-form-item :label="$t('resource.productInfo.path')" prop="path">
            <t-input v-model="productInfoForm.path" maxLength="255">
              <t-button
                slot="append"
                icon="el-icon-folder"
                type="success"
                style="width: 50px"
                @click="ChangeFile()"
              ></t-button>
            </t-input> </t-form-item
        ></t-col> -->
      </t-row>

      <!-- 備考 -->
      <!--  <t-row>
        <t-col>
          <t-form-item :label="$t('resource.productInfo.bikou')" prop="bikou">
            <t-input
              v-model="productInfoForm.bikou"
              maxLength="255"
              class="bikou"
            ></t-input> </t-form-item
        ></t-col>
      </t-row> -->
      <t-row>
        <t-col :span="12">
          <t-form-item :label="$t('resource.productInfo.path')" prop="path">
            <t-upload
              class="avatar-uploader"
              action="https://jsonplaceholder.typicode.com/posts/"
              :show-file-list="true"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </t-upload> </t-form-item
        ></t-col>
      </t-row>

      <t-row type="flex" justify="end">
        <div>
          <t-col :span="24">
            <t-button
              type="primary"
              style="width: 100px; height: 40px; align: center"
              class="button-default"
              @click="Confirm"
              >{{ $t("resource.sys.sure") }}</t-button
            >
          </t-col>
        </div>
      </t-row>
    </t-form>
  </t-card>
</template>
<script>
export default {
  data() {
    return {
      /*productInfoForm: {
        //authorityKbnList: [],
        //authorityKbn: "0000",
      },*/
      imageUrl: "",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,

      productInfoForm: {
        productCode: "",
        productName: "",
        materialNum: "",
        diagram: "",
        weight: "",
        volume: "",
        shape: "",
        path: "",
        unit: "",
        currency: "",
        bikou: "",
      },
      disabled: false,
      /*authorityKbn: [
        { label: "操作", value: "1" },
        { label: "アラーム割当", value: "2" },
        { label: "設定", value: "3" },
        { label: "管理者", value: "4" },
      ],*/
    };
  },
  props: {
    isAdd: {
      Type: Boolean,
      default: false,
    },
    productCode: {
      Type: String,
      default: "",
    },
    productName: {
      Type: String,
      default: "",
    },
    materialNum: {
      Type: String,
      default: "",
    },
    diagram: {
      Type: String,
      default: "",
    },
    weight: {
      Type: String,
      default: "",
    },
    volume: {
      Type: String,
      default: "",
    },
    shape: {
      Type: String,
      default: "",
    },
    path: {
      Type: String,
      default: "",
    },
    unit: {
      Type: String,
      default: "",
    },
    currency: {
      Type: String,
      default: "",
    },
    bikou: {
      Type: String,
      default: "",
    },
  },
  mounted() {
    if (!this.isAdd) {
      // console.log("init start");
      // console.log("path = " + this.path);
      // console.log("materialNum = " + this.materialNum);

      this.Init({
        productCode: this.productCode,
        productName: this.productName,
        materialNum: this.materialNum,
        diagram: this.diagram,
        weight: this.weight,
        volume: this.volume,
        shape: this.shape,
        path: this.path,
        unit: this.unit,
        currency: this.currency,
        bikou: this.bikou,
      });
      this.disabled = true;
    }
  },
  methods: {
    // 初期化
    Init(data) {
      this.productInfoForm = data;
      // console.log("Init :path = " + this.path);
    },
    // 編集
    Confirm() {
      this.$refs.productInfoForm.validate((valid) => {
        if (valid) {
          /*add(this.productInfoForm);

          if (!this.CheckDate()) {
            return false;
          }*/
          //this.productInfoForm.updateUser = localStorage.getItem("userId");

          this.$emit("ok", "ok");
        }
      });
    },
    // ダイアログを閉じる
    Close() {
      this.$emit("cancel");
    },
    GetPic(path) {
      // console.log("GetPic1: path1 = " + path);

      const images = {
        "@/assets/images/nut_001.png": require("@/assets/images/nut_001.png"),
        "@/assets/images/nut_002.png": require("@/assets/images/nut_002.png"),
        "@/assets/images/nut_003.png": require("@/assets/images/nut_003.png"),
        "@/assets/images/crop-rate.png": require("@/assets/images/crop-rate.png"),
      };

      return images[path];
      // return require("@/assets/images/crop-rate.png");
    },

    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    /*  add(obj) {
      readFile(filePath, 'utf-8', (err, data) => {
        if (err) throw err
        let res = JSON.parse(data)
        // 需要得到id，id为数组中最后一个图书的id+1
        let index = res[res.length - 1].cusCode + 1
        // 向obj对象中添加id属性
        obj.cusCode = index
        res.push(obj)
        // 写入到json文件中 --> 需要把res转为字符串写入到json文件
        writeFile(filePath, JSON.stringify(res), err => {
            if (err) throw err
            console.log('添加成功')
        })
    })
  }, */
    // 日付書式設定
    /*DateFormat(_row, column, cellValue, index) {
      return DateFormat(cellValue, "yyyy/MM/dd");
    },*/
    /*changeauthorityKbn() {
      let data = [];
      if (this.productInfoForm.authorityKbnList.some((even) => even === "1")) {
        data[0] = "1";
      } else {
        data[0] = "0";
      }
      if (this.productInfoForm.authorityKbnList.some((even) => even === "2")) {
        data[1] = "1";
      } else {
        data[1] = "0";
      }
      if (this.productInfoForm.authorityKbnList.some((even) => even === "3")) {
        data[2] = "1";
      } else {
        data[2] = "0";
      }
      if (this.productInfoForm.authorityKbnList.some((even) => even === "4")) {
        data[3] = "1";
      } else {
        data[3] = "0";
      }
      this.productInfoForm.authorityKbn = data.join("");
    },
    CheckDate() {
      const startDate = this.productInfoForm.startDate;
      const endDate = this.productInfoForm.endDate;
      if (startDate && endDate && endDate < startDate) {
        Modal.showError("", t("message.master.dateCheck"))
          .then(() => {})
          .catch(() => {});
        return false;
      }
      return true;
    },*/
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-input--prefix .el-input__inner {
  width: 264px;
}
::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 264px;
}
</style>
